import { TAnnouncementType } from '../../constants/common';
import { TRecruitmentType } from '../../constants/position/common';
import { ITag, TCareerType, TSubmissionStatusType } from './IRecruitSetting';

export const WRITE_BUTTON_STATUS = {
  OPEN: 'OPEN',
  CLOSE: 'CLOSE',
} as const;
export type TWriteButtonStatus = keyof typeof WRITE_BUTTON_STATUS;

export interface IJD extends IJD_BASE {
  // jobda
  address?: string;
  detailAddress?: string;
  region?: string;

  // jobflex
  jobGroup: string;
  classificationCode?: string;
  recruitmentType?: TRecruitmentType;
  attachFileDtoList?: IJDFile[];
  writeButtonStatus?: TWriteButtonStatus;

  // PRIVATE일 때
  resumeUpdateUrl?: string;
  myPageUrl?: string;
}

export interface IJD_BASE {
  // common
  title: string;
  jobDescription: string;
  jobDescriptionType: 'HTML' | 'JSON';
  careerType: TCareerType;
  announcementType: TAnnouncementType;
  startDateTime: string;
  endDateTime: string;
  tagList: ITag[];
  dday: number;
  submissionStatus: TSubmissionStatusType;
  applyUrl: string;
}

export interface IJDFile {
  fileName: string;
  fileUrl: string;
}
